// extracted by mini-css-extract-plugin
export default {"body":"Terms_body__0gH5o","inner":"Terms_inner__Z50Im","content":"Terms_content__FOYct","privacy":"Terms_privacy__aPkIZ"};